<script setup lang="ts">
  import { useModal } from 'vue-final-modal';
  import { FieldSearchBar, ColoredButton, SearchToolbar, SelectInput } from '@/shared/ui';
  import { useDocumentList } from '@/features/Document';
  import { SEARCH_TYPE_FIELD_OPTIONS } from '@/shared/lib';
  import { QUANTITY_OPTIONS } from '@/shared/config';
  import registrationPaper from '@/shared/assets/icons/RegistrationPaper.svg';
  import uploadIcon from '@/shared/assets/icons/UploadIcon.svg';
  import listIcon from '@/shared/assets/icons/ListIcon.svg';
  import exportExcelIcon from '@/shared/assets/icons/ExportExcel.svg';
  import MasterListModal from '@/features/Document/ui/MasterListModal.vue';

  defineProps<{
    hasDocuments?: boolean;
    selectedQuantity: number;
    shouldShowQuantitySelect: boolean;
    exportDisabled?: boolean;
    exportLoading?: boolean;
  }>();

  const emit = defineEmits<{
    search: [queryString: string];
    'open-external-upload': [];
    'export-to-excel': [];
    'quantity-change': [value: string | number];
  }>();

  const handleSearch = (queryString: string) => {
    emit('search', queryString);
  };

  const handleQuantityChange = (value: string | number) => {
    emit('quantity-change', value);
  };

  const { openDistributionList } = useDocumentList();

  const handleOpenExternalUpload = () => {
    emit('open-external-upload');
  };

  const handleExportToExcel = () => {
    emit('export-to-excel');
  };

  const { open: openMasterList, close: closeMasterList } = useModal({
    component: MasterListModal,
    attrs: {
      title: 'Lista Mestra',
      onClose: () => closeMasterList(),
      modelValue: true,
    },
  });
</script>

<template>
  <div class="w-full h-full flex-col gap-4 mt-6">
    <div class="flex gap-4 items-center justify-start mb-6">
      <ColoredButton
        text="Lista Mestra"
        :icon="registrationPaper"
        alt-icon="Lista Mestra"
        variant="active"
        @click="openMasterList"
      />
      <ColoredButton
        text="Upload DE"
        :icon="uploadIcon"
        icon-alt="Upload"
        @click="handleOpenExternalUpload"
      />
      <ColoredButton
        text="Exportar para Excel"
        :icon="exportExcelIcon"
        icon-alt="Exportar"
        :disabled="exportDisabled"
        :loading="exportLoading"
        @click="handleExportToExcel"
      />
      <ColoredButton
        text="Lista de Distribuição"
        :icon="listIcon"
        icon-alt="Lista de Distribuição"
        @click="openDistributionList"
      />
    </div>
    <SearchToolbar class="mb-6">
      <template #search>
        <FieldSearchBar
          :search-fields="SEARCH_TYPE_FIELD_OPTIONS"
          :initial-search-term="''"
          class="w-full"
          @search="handleSearch"
        />
      </template>
      <template
        v-if="shouldShowQuantitySelect"
        #quantity
      >
        <SelectInput
          :model-value="selectedQuantity"
          :options="QUANTITY_OPTIONS"
          class="cursor-pointer"
          @update:model-value="handleQuantityChange"
        />
      </template>
    </SearchToolbar>
  </div>
</template>
